module.exports = __webpack_public_path__ + "media/images/greennote 7-dbba55103a3f48139a62b722355defe8.svg";